export default __webpack_public_path__ + "static/media/resume_eng.8ae46f20.pdf";